export default {
  namespaced: true,
  state: {
    dates: null,
    beginDate: null,
    untilDate: null,
    selectedProviders: null,
    selectedCompanies: null,
    currentDateRange: null,
  },
  mutations: {
    setDates(state, data) {
      state.dates = data
    },
    setBeginDate(state, data) {
      state.beginDate = data
    },
    setUntilDate(state, data) {
      state.untilDate = data
    },
    setSelectedProviders(state, data) {
      state.selectedProviders = data
    },
    setSelectedCompanies(state, data) {
      state.selectedCompanies = data
    },
    setCurrentDateRange(state, data) {
      state.currentDateRange = data
    },
  },
  getters: {
    getDates(state) {
      return state.dates
    },
    getBeginDate(state) {
      return state.beginDate
    },
    getUntilDate(state) {
      return state.untilDate
    },
    getSelectedProviders(state) {
      return state.selectedProviders
    },
    getSelectedCompanies(state) {
      return state.selectedCompanies
    },
    getCurrentDateRange(state) {
      return state.currentDateRange
    },
  },
}
